const subscriptionStatus = {
    SUBSCRIPTION_EXPIRED : "subscription_expired",
    USER_LIMIT_REACHED: "users_limit_reached",
    TRIAL_ENDED: "trial_subscription_ended",
    ACCESS_DENIED: "access_denied",
    SUBSCRIBED:"subscribed"
  };
  
  export default subscriptionStatus;
  